export type ComponentCompatibility = "COMPATIBLE" | "INCOMPATIBLE" | "UNKNOWN";

export interface ComponentReleaseIdentity {
  readonly webSha: string;
  readonly compatibleApiSha: string;
}

const SHA = /^[0-9a-f]{40}$/;

export function componentReleaseIdentity(): ComponentReleaseIdentity | null {
  const webSha = typeof __BUILD_ID__ === "string" ? __BUILD_ID__ : undefined;
  const compatibleApiSha =
    typeof __COMPATIBLE_API_ID__ === "string" ? __COMPATIBLE_API_ID__ : undefined;
  if (webSha === undefined || compatibleApiSha === undefined) return null;
  if (!SHA.test(webSha) || !SHA.test(compatibleApiSha)) return null;
  return { webSha, compatibleApiSha };
}

export function componentCompatibility(apiSha: string): ComponentCompatibility {
  const identity = componentReleaseIdentity();
  if (identity === null || !SHA.test(apiSha)) return "UNKNOWN";
  return identity.compatibleApiSha === apiSha ? "COMPATIBLE" : "INCOMPATIBLE";
}
